interface UrlParam {
    name: string;
    value: string;
}

export const addQueryParamToUrl = (url: string, param: UrlParam) => {
    const urlObject = new URL(url);

    if (param.value) urlObject.searchParams.set(param.name, param.value);
    else urlObject.searchParams.delete(param.name);

    return urlObject.toString();
};

export const addQueryParamsToUrl = (url: string, params: UrlParam[]) => {
    let resultUrl = url;

    params.forEach((param) => {
        resultUrl = addQueryParamToUrl(resultUrl, param);
    });

    return resultUrl;
};
